import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router';
import store from './store'

import request from './utils/request'
Vue.prototype.$http = request

Vue.use(ElementUI);

import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  created(){
	store.commit('addmenu',router)  
  },
  render: h => h(App),
}).$mount('#app')
